import { ProgressBar } from "primereact/progressbar";
import React, { useState } from "react";
import iconDownload from "../../../assets/img/interna/download.png";
import {
  CertificadoFProgramaEspecializacion,
  CertificadoFProgramaEspecializacionNotas,
} from "../../../services/CertificadosServices";
import { ListarCursos, ObtenerEncuestaPersonaPrograma } from "../../../services/CursoService";
import { ObtenerCertificadoPersonaPrograma } from "../../../services/UsuarioService";
import EncuastaPrograma from "../../components/CardEncuentasPrograma/EncuestaPrograma";
import useAlumno from "../../../hooks/useAlumno";
import { Tooltip } from "primereact/tooltip";
import { useNavigate, useParams } from "react-router-dom";
import { PrivateRoutes } from "../../../routes/routes";
import { handleDownloadCertificado, urlToShare } from "../../../helpers/helpers";
import { toast } from "react-toastify";
import * as constantes from "../../../constants/constantes.js";

function CardBienvenidaProgramaComponent({
  Persona,
  programa,
  listaProgresoLeccionUnidadeCursoPrograma,
  listaLeccionUnidadeCursoPrograma,
  listaEvaluacionesUnidadeCursoPrograma,
  listaUnidadeCursoPrograma,
  listaCursoPrograma,
  setspinnerCertificado,
  spinnerCertificado,
  ProgressSpinner,
  setspinnerNotas,
  spinnerNotas,
  PersonaProgamaData
}) {

  const navigate = useNavigate();
  let {idCurso} = useParams();
  let { configuraciones } = useAlumno();
  const [ProgresoPrograma, setProgresoPrograma] = useState(0);
  /*encuesta */
  const [mostrarEncuestas, setmostrarEncuestas] = useState(false);
  const [idEncuestas, setidEncuestas] = useState(0);
  const [AlertaEstaPorvencer, setAlertaEstaPorvencer] = useState(false);
  const [ShowEstaPorvencer, setShowEstaPorvencer] = useState(false);
  const [isButtonDisabledCertificado, setButtonDisabledCertificado] =
    useState(false);
    const [isButtonDisabledNotas, setButtonDisabledNotas] =
    useState(false);

  function ProgresoProgramaPormedio() {

    if (listaProgresoLeccionUnidadeCursoPrograma != null) {
      let sum = 0;
      for (
        var i = 0;
        i < listaProgresoLeccionUnidadeCursoPrograma.length;
        i++
      ) {
        sum += listaProgresoLeccionUnidadeCursoPrograma[i].PorcentajeAvance;
      }
      const average = sum / listaLeccionUnidadeCursoPrograma.length / 2;
      var evaluacionCursoFilter = listaEvaluacionesUnidadeCursoPrograma.filter(
        (x) => x.intento === 1
      );
      const evaluacionPorcentaje =
        (evaluacionCursoFilter.length * 100) /
        listaUnidadeCursoPrograma.length /
        2;
      setProgresoPrograma(average + evaluacionPorcentaje);
      let id = listaCursoPrograma[0].idPersonaPrograma;
      let jwt = window.localStorage.getItem("jwt");
      if ((average + evaluacionPorcentaje).toFixed() >= 50 && (average + evaluacionPorcentaje).toFixed() < 100) {
        ObtenerEncuestaPersonaPrograma({ jwt, id }).then((data) => {
          if (data.length <= 0) {
            setmostrarEncuestas(true);
            setidEncuestas(1)
          }
        })
      }
      if ((evaluacionPorcentaje).toFixed() >= 50) {
        ObtenerEncuestaPersonaPrograma({ jwt, id }).then((data) => {
          if (data.length > 0) {
            if (data[0].segundaEncuestaProgramaRealizada != true) {
              setmostrarEncuestas(true);
              setidEncuestas(2)
            }
          }
          else {
            setmostrarEncuestas(true);
            setidEncuestas(1)
          }
        })
      }
      if (average.toFixed(2) != 0) {
        return <span className="avance_description_responsive">
          Has avanzado el {(average + evaluacionPorcentaje).toFixed()}% del
          programa ¡Sigue así!
        </span>;
      } else {
        return (
          <span className="avance_description_responsive">
            Has avanzado el {(average + evaluacionPorcentaje).toFixed()}% del
            programa ¡Sigue así!
          </span>
        );
      }
    } else {
      return <span>0.00</span>;
    }
  }
  const valueTemplate = () => {
    return <React.Fragment>{""}</React.Fragment>;
  };

  const onDownloadCertificadoPrograma = async() => {
        
    try{
      navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Program/" + PersonaProgamaData.idPrograma + "/" + PersonaProgamaData.idPersonaPrograma  + "/" +  idCurso,{
        state: {downloading:true}
      });

        const res = await handleDownloadCertificado({
            cursoPersona: PersonaProgamaData,
            listaCursoPrograma: listaCursoPrograma,
            programa: programa,
            persona: Persona,
            tipo:"Program"
        });

        console.log('urlCertificado',res)
        navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Program/" + PersonaProgamaData.idPrograma + "/" + PersonaProgamaData.idPersonaPrograma  + "/" + idCurso,{
            state: {downloading:false, res}
        });

    }catch(error){
        toast.error(error,{ autoClose: 3000})
    }
  };

  const handleDownloadNotasPrograma = async () => {
    let jwt = window.localStorage.getItem("jwt");
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getMonth() + 1).padStart(2, '0')}_${String(currentDate.getFullYear()).slice(-2)}`;
    let IDPersonaPrograma = listaCursoPrograma[0].idPersonaPrograma;
    ObtenerCertificadoPersonaPrograma({ jwt, IDPersonaPrograma }).then(async (dataCert) => {
      let nombrealumno =
        (Persona.nombres == null ? " " : Persona.nombres.trim()) +
        " " +
        (Persona.primerApellido == null ? " " : Persona.primerApellido.trim()) +
        " " +
        (Persona.segundoApellido == null ? " " : Persona.segundoApellido.trim());
      let nombrecursoprograma = programa.nombre;
      let ubicacion = "Lima";
      let enlace = urlToShare //dataCert.LinkCDN
          ? `${urlToShare}${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}.pdf`
          : '';
      const fileName = `${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}`;
      const codigo = dataCert.codigoCertificado;
      const enlaceQR = constantes.URL_CERTIFICATE +"/ValidateCertificateQR?codigo="+ dataCert.codigoCertificado + "&tipo=2";
      let promedionotaD = 0;
      var detalle = [];
      for (var i = 0; i < listaCursoPrograma.length; i++) {
        var unidadesDat = listaUnidadeCursoPrograma.filter(
          (x) => x.idCurso === listaCursoPrograma[i].idCurso
        );
        let notaMasAlta = 0;
        for (var j = 0; j < unidadesDat.length; j++) {
          var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
            (x) => x.idUnidad === unidadesDat[j].idUnidad
          );
          let notas;
          if (evaluacionesUnidad.length > 0) {
            notas = evaluacionesUnidad.map((evaluacion) => evaluacion.nota);
            notaMasAlta = notaMasAlta + Math.max(...notas);
          }
        }
        notaMasAlta = notaMasAlta / unidadesDat.length;
        let detalleUnidad = {
          nombremodulo: listaCursoPrograma[i].curso.nombre,
          promedio: notaMasAlta.toFixed(0),
          orden: i + 1,
        };
        promedionotaD = promedionotaD + notaMasAlta;
        detalle.push(detalleUnidad);
      }
      promedionotaD = (promedionotaD.toFixed(0) / listaCursoPrograma.length).toFixed(0);
      let promedionota = promedionotaD.toString();
      let jsonData = JSON.stringify({
        nombrealumno,
        nombrecursoprograma,
        ubicacion,
        enlace,
        enlaceQR,
        codigo,
        promedionota,
        detalle,
      });
      const dataCDN = {
        Extension: enlace.split('.').pop(),
        NombreCDN: fileName
       };
      try {
        setspinnerNotas(true)
        setButtonDisabledNotas(true)
        const response = { link: enlace, fileName };
        await CertificadoFProgramaEspecializacionNotas({ jwt, jsonData, dataCDN, response }).then(
          (data) => { }
        );
        setButtonDisabledNotas(false)
        setspinnerNotas(false)
      } catch (error) {
        setspinnerNotas(false)
        alert.error(
          "Error en la función CertificadoFProgramaEspecializacionNotas:",
          error
        );
      }
    })
  };

  function duracionEnHoras(duracion) {
    const partes = duracion.split(" ");
    if (partes.length === 2 && partes[1] === "h") {
      return parseFloat(partes[0]);
    }
    return 0;
  }


  function programaEstadoEvaluacionResultados() {
    var promedio = 0;
    let band = true;
    if (listaCursoPrograma) {
      listaCursoPrograma.forEach(element => {
        if (element.idEstado != 1 || element.idCondicion == 2) {
          band = false;
        }
        promedio = parseFloat(promedio) + parseFloat(calcularPromedioNotasPorUnidad(element.idCurso)); 
      });
    }
    if (band) {
      if (promedio < configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor) {
        return false;
      }
      else {
        return true;
      }
    }
    else {
      return band
    }
  }

  function calcularPromedioNotasPorUnidad(idCurso) {
    if (listaEvaluacionesUnidadeCursoPrograma) {
      var unidades = listaUnidadeCursoPrograma.filter(
        (x) => x.idCurso === idCurso
      );
      var promediototal = 0;
      for (var k = 0; k < unidades.length; k++) {
        if (listaEvaluacionesUnidadeCursoPrograma.length > 0) {
          var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
            (x) => x.idUnidad === unidades[k].idUnidad
          );
          if (evaluacionesUnidad.length > 0) {
            const notas = evaluacionesUnidad.map(
              (evaluacion) => evaluacion.nota
            );
            const notaMasAlta = Math.max(...notas);
            promediototal = promediototal + notaMasAlta;
          }
        }
      }
      promediototal = promediototal / unidades.length;
      return promediototal.toFixed(2);
    } else {
      return 0;
    }
  }
  return (
    <><EncuastaPrograma
      idEncuestas={idEncuestas}
      mostrarEncuestas={mostrarEncuestas}
      programa={programa}
      listaCursoPrograma={listaCursoPrograma} />
      <div className="field col-12 md:col-7 card__contenedor__responsive" style={{paddingRight: "1.2rem"}}>
        <div className=" rounded-9 shadow card__bienvenida_responsive p-md-4  mb-2 md-4 cardTabs" style={{minHeight:"64%"}}>
          <div className="row g-2  align-items-center">
            <div className="rounded-10  p-md-4  mb-md-4">
              <div className="p-fluid formgrid grid">
                <div className="field col-12 md:col-12 fontsizeinitial space_bottom">
                  <span className=" h3 titulo_bienvenida_responsive" data-v-48f3e599="">
                  ¡Hola {Persona.nombres && Persona.nombres.split(' ')[0]}!
                  
                  </span>
                  <span className="description_bienvenida_responsive fontsizeinitial h3" data-v-48f3e599="" >
                    Te damos la bienvenida al programa "{programa.nombre}"
                  </span>


                  {listaProgresoLeccionUnidadeCursoPrograma && (
                    <ProgresoProgramaPormedio />
                  )}
                  {" "}



                </div>
              </div>
              <div className="barra__progreso__Responsive" >
                <ProgressBar
                  value={ProgresoPrograma}
                  displayValueTemplate={valueTemplate}
                  style={{ height: "8px", borderRadius: "0px" }}
                  color="#FFB62F"

                ></ProgressBar>
              </div>
            </div>
          </div>
        </div>

        <div className="p-fluid formgrid grid progreso-desktop-flex ">
          <div className=" col-35 md:col-6 mt-1">
            <div className="p-fluid formgrid grid ">
              <div
                className=" col-12 md:col-9"
                style={{ paddingRight: 0, height: "80px" }}
              >
                <div
                  className="border rounded-9 shadow p-md-4  mb-md-4 cardTabsArchivos"
                  style={{ height: "100%" }}
                >
                  <span className="subtitle text-sm h3" data-v-48f3e599="">
                    Certificado del programa
                  </span>
                </div>
              </div>
              <div className=" col-12 md:col-3" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div
                  className={listaCursoPrograma && listaEvaluacionesUnidadeCursoPrograma && programaEstadoEvaluacionResultados() && isButtonDisabledCertificado == false
                    ? "flex align-items-center justify-content-center interna-material-download"
                    : "flex align-items-center justify-content-center interna-material-download-apagado botonesprograma"}
                  style={{
                    height: "80px",
                  }}
                  onClick={() => {
                    //cambiar al orden correcto
                    if (listaCursoPrograma && listaEvaluacionesUnidadeCursoPrograma && programaEstadoEvaluacionResultados()) {
                        onDownloadCertificadoPrograma()
                    }
                  }}
                >
                  <Tooltip
                    target=".botonesprograma"
                    content={
                      listaCursoPrograma
                      && listaEvaluacionesUnidadeCursoPrograma 
                      && programaEstadoEvaluacionResultados() 
                      && isButtonDisabledCertificado == false
                        ? ""
                        : PersonaProgamaData?.idCondicion == 2 && PersonaProgamaData?.finPrograma != null
                          ? "Este botón se encuentra desactivado, dado que desaprobaste el programa." 
                          : "Este botón se encuentra desactivado, dado que aún no terminas el programa."
                    }
                    className="white-tooltip"
                  />
                 {spinnerCertificado ? (
                        <ProgressSpinner
                            style={{ width: "50px", height: "50px" }}
                        />
                    ) : (
                        <img
                            src={iconDownload}
                            width={"17.5px"}
                            height={"21px"}
                        ></img>
                    )}
                </div>
              </div>
            </div>
          </div>

          <div className=" col-35 md:col-6 mt-1" style={{ paddingRight: 0 }}>
            <div className="p-fluid formgrid grid">
              <div className=" col-12 md:col-9" style={{ paddingRight: 0, height: "80px" }}>
                <div className="border rounded-9 shadow  p-md-4  mb-md-4 cardTabsArchivos" style={{ height: "100%" }}>
                  <span className="text-sm h3" style={{marginTop:"10px"}} data-v-48f3e599="">
                    Detalle de notas del programa
                  </span>
                </div>
              </div>
              <div className=" col-12 md:col-3" style={{ paddingLeft: 0, height: "80px", paddingRight: 0 }}>
                <div
                  className={listaCursoPrograma && listaEvaluacionesUnidadeCursoPrograma && programaEstadoEvaluacionResultados() &&  isButtonDisabledNotas == false
                    ? "flex align-items-center justify-content-center interna-material-download"
                    : "flex align-items-center justify-content-center interna-material-download-apagado botonesprograma"}
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "flex-end"
                  }}
                  onClick={() => {
                    if (listaCursoPrograma && listaEvaluacionesUnidadeCursoPrograma && programaEstadoEvaluacionResultados()) {
                      handleDownloadNotasPrograma();
                    }
                  }}
                >
                  {spinnerNotas ? (
                        <ProgressSpinner
                            style={{ width: "50px", height: "50px" }}
                        />
                    ) : (
                        <img
                            src={iconDownload}
                            width={"17.5px"}
                            height={"21px"}
                        ></img>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div></>
  );
}

export default CardBienvenidaProgramaComponent;
